import { render } from "./ZijinDetails.vue?vue&type=template&id=1239be0c&scoped=true"
import script from "./ZijinDetails.vue?vue&type=script&lang=js"
export * from "./ZijinDetails.vue?vue&type=script&lang=js"

import "./ZijinDetails.vue?vue&type=style&index=0&id=1239be0c&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1239be0c"]])

export default __exports__